import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, DatePicker, Input } from 'antd';
import dayjs from '../../../lib/dayjs';
import { AlimtalkSendFormValues } from '../../../types/alimtalk/form';
import * as Styled from './style';

const rangeUntil = (end: number): number[] => Array.from({ length: end }, (_, index) => index);

/** 오늘 날짜를 고른 경우의 시/분 제한 — 호출 시점의 현재 시각 기준(모듈 로드 시점이 아님) */
const getTodayDisabledTime = () => {
  const now = dayjs();
  return {
    disabledHours: () => rangeUntil(now.hour()),
    disabledMinutes: (selectedHour: number) => (selectedHour === now.hour() ? rangeUntil(now.minute() + 1) : []),
  };
};

export const ScheduleSection = () => {
  const { control, watch, setValue } = useFormContext<AlimtalkSendFormValues>();
  const scheduledAt = watch('scheduledAt');
  const isImmediate = scheduledAt === null;

  // 운영자가 고른 KST wall-clock을 오프셋 포함 ISO(예: 2026-06-16T11:00:00+09:00)로 전송 — UTC 'Z' 변환의 9시간 혼동 방지
  const handleImmediateChange = (checked: boolean): void => {
    setValue('scheduledAt', checked ? null : dayjs().add(1, 'hour').startOf('hour').format());
  };

  return (
    <Styled.Section>
      <Styled.SectionTitle>메모 · 예약</Styled.SectionTitle>

      <Styled.FieldRow>
        <Styled.FieldLabel>메모<Styled.RequiredMark>*</Styled.RequiredMark></Styled.FieldLabel>
        <Controller
          control={control}
          name="memo"
          render={({ field }) => (
            <Input.TextArea {...field} rows={3} placeholder="예: 7월 4주차 주말특가 알림톡" maxLength={500} />
          )}
        />
      </Styled.FieldRow>

      <Styled.FieldRow>
        <Styled.FieldLabel>예약 시간</Styled.FieldLabel>
        <Checkbox checked={isImmediate} onChange={(e) => handleImmediateChange(e.target.checked)}>
          즉시 발송
        </Checkbox>
        {!isImmediate && (
          <Controller
            control={control}
            name="scheduledAt"
            render={({ field }) => (
              <DatePicker
                showTime
                style={{ width: 240 }}
                disabledDate={(date) => date.isBefore(dayjs(), 'day')}
                // disabledDate는 날짜 단위라 오늘을 고르면 지난 시각이 통과한다 — 오늘에 한해 시/분도 함께 막는다
                disabledTime={(date) => (date && date.isSame(dayjs(), 'day') ? getTodayDisabledTime() : {})}
                value={field.value ? dayjs(field.value) : null}
                onChange={(date) => field.onChange(date ? date.format() : null)}
              />
            )}
          />
        )}
      </Styled.FieldRow>
    </Styled.Section>
  );
};
